<template>
  <div class="container">
    <div v-if="user" class="row">
      <div class="col-12 clear-fix">
        <a :href="user.url">
          <div class="profile">
            <img v-if="user.imageUrl" class="icon" :src="user.imageUrl" :alt="user.name" />
            <img v-else class="icon drop" :src="album.dropIconUrl" alt="" />
            <span class="name">{{ user.name }}</span>
          </div>
        </a>
        <div v-if="album.editable" class="btns h-100">
          <a :href="album.editUrl">編集</a>
          <a :href="album.deleteUrl" data-turbo-method="delete" :data-turbo-confirm="deleteConfirm">削除</a>
        </div>
      </div>
    </div>
    <template v-else>
      <div v-if="album.author" class="row">
        <div class="col-12 clear-fix">
          <div class="profile">
            <img class="icon drop" :src="album.dropIconUrl" alt="" />
            <span class="name">{{ album.author }}</span>
          </div>
          <div v-if="album.editable" class="btns">
            <a :href="album.editUrl">編集</a>
            <a :href="album.deleteUrl" data-turbo-method="delete" :data-turbo-confirm="deleteConfirm">削除</a>
          </div>
        </div>
      </div>
      <div v-else-if="album.editable" class="row">
        <div class="col-12 clear-fix">
          <div class="btns">
            <a :href="album.editUrl">編集</a>
            <a :href="album.deleteUrl" data-turbo-method="delete" :data-turbo-confirm="deleteConfirm">削除</a>
          </div>
        </div>
      </div>
    </template>

    <div class="row">
      <div class="col-12 clearfix">
        <div class="h3 mr-3">
          <span v-if="!album.published" class="editing">下書き</span>
          <span v-if="album.private" class="editing">部内公開</span>
          {{ title || 'タイトルなし' }}
        </div>
        <div class="float-right mb-2">
          <div class="btn-group">
            <div
              class="btn btn-sm"
              :class="view_type == 1 ? 'btn-dark active' : 'btn-dark'"
              @click="view_type = 1"
            >
              <span class="fa fa-picture-o"></span>
            </div>
            <div
              class="btn btn-sm"
              :class="view_type == 2 ? 'btn-dark active' : 'btn-dark'"
              @click="view_type = 2"
            >
              <span class="fa fa-align-justify"></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <PhotoModal
      v-if="modal && photos[count]"
      :photo="photos[count]"
      :count="count"
      :total="photos.length"
      @close="modal = false"
      @prev="decrement"
      @next="increment"
    />

    <div v-if="fetching" class="row loading">
      <div class="col-12 col-sm-9 push-sm-3">読み込み中...</div>
      <div class="col-12 col-sm-6 push-sm-3">
        <div class="photo-wrapper">
          <img :src="album.primaryThumbUrl" alt="" />
        </div>
      </div>
    </div>

    <div v-else-if="view_type == 1" class="row photos">
      <div
        v-for="(photo, index) in photos"
        :id="'photo-' + photo.id"
        :key="photo.id"
        class="col-6 col-md-4 col-lg-3"
      >
        <PhotoCard :photo="photo" layout="grid" @open="openModal(index)" />
      </div>
    </div>

    <div v-else class="row photos-article">
      <div
        v-for="(photo, index) in photos"
        :id="'photo-' + photo.id"
        :key="photo.id"
        class="col-12 col-md-4 col-lg-3"
      >
        <PhotoCard :photo="photo" layout="card" @open="openModal(index)" />
      </div>
    </div>
  </div>
</template>

<script>
import PhotoCard from './components/PhotoCard.vue'
import PhotoModal from './components/PhotoModal.vue'
import { getAlbum } from '../../lib/albums'

export default {
  name: 'AlbumsShowApp',
  components: { PhotoCard, PhotoModal },
  props: {
    albumId: { type: String, required: true },
    album: { type: Object, required: true },
    user: { type: Object, default: null },
  },
  data() {
    return {
      title: this.album.title,
      photos: [],
      fetching: true,
      modal: false,
      count: 0,
      view_type: 2,
      deleteConfirm: 'アルバムを削除しますか？',
    }
  },
  created() {
    if (!this.albumId) return

    getAlbum(this.albumId)
      .then((res) => {
        this.title = res.title
        this.photos = res.photos
        this.fetching = false
      })
      .catch(() => {
        window.alert('アルバムを取得できませんでした・ω・')
      })
  },
  mounted() {
    window.addEventListener('keydown', this.onKeydown)
  },
  beforeUnmount() {
    window.removeEventListener('keydown', this.onKeydown)
  },
  methods: {
    onKeydown(e) {
      if (e.key === 'ArrowRight') this.increment()
      if (e.key === 'ArrowLeft') this.decrement()
    },
    openModal(photoIndex) {
      this.count = photoIndex
      this.modal = true
      this.moveToPhoto()
    },
    increment() {
      this.count = this.count + 1
      this.moveToPhoto()
    },
    decrement() {
      this.count = this.count - 1
      this.moveToPhoto()
    },
    moveToPhoto() {
      const photo = this.photos[this.count]
      if (!photo) return
      const el = document.getElementById(`photo-${photo.id}`)
      if (!el) return
      const top = el.getBoundingClientRect().top + window.pageYOffset - 100
      window.scrollTo({ top, behavior: 'auto' })
    },
  },
}
</script>
